/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/workPermitList.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { GET_WORK_PERMIT_LIST } from '../../api/graphql';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IWorkPermitListMethods extends IPluginMethodMap {
  getWorkPermitList(args: any): Promise<any>;
}

export class WorkPermitListService implements IAgentPlugin {
  readonly methods: IWorkPermitListMethods;

  constructor() {
    this.methods = {
      getWorkPermitList: this.getWorkPermitList.bind(this),
    };
  }

  private async getWorkPermitList(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_WORK_PERMIT_LIST, {
          input: {
            skip: args?.offset,
            limit: args?.size || 10,
            where: [
              ...(args?.where ?? []),
              // {
              //   column: 'status',
              //   op: 'In',
              //   value: ['SUBMITTED'],
              // },
            ],
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfWorkPermit?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            data: _rowData,
            //hi
            isEmpty: _rowData
              ? res?.data?.getListOfWorkPermit?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfWorkPermit?.currentPage,
            pageSize: res?.data?.getListOfWorkPermit?.pageSize,
            totalCount: res?.data?.getListOfWorkPermit?.totalCount,
            totalPages: res?.data?.getListOfWorkPermit?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        console.log(item);
        return {
          applicationId: item?.credentialNo,
          id: item?.credentialNo,
          title: item?.credentialNo,
          badges: [this.getFormattedStatus(item?.status)],
          listImg: 'WP',
          type: 'WP',
          name: item?.issuedTo
            ? item?.issuedTo?.firstName
              ? `${
                  item?.issuedTo?.lastName
                    ? toHeaderCase(item?.issuedTo?.lastName ?? '')
                    : ''
                }, ${toHeaderCase(item?.issuedTo?.firstName)} ${
                  item?.issuedTo?.middleName
                    ? toHeaderCase(item?.issuedTo?.middleName ?? '')
                    : ''
                }`
              : ''
            : `${
                item?.application?.applicantInfo?.lastName
                  ? toHeaderCase(
                      item?.application?.applicantInfo?.lastName ?? ''
                    )
                  : ''
              } ${toHeaderCase(item?.application?.applicantInfo?.firstName)}`,
          meta: [
            item?.issuedTo
              ? item?.issuedTo?.firstName
                ? `${
                    item?.issuedTo?.lastName
                      ? toHeaderCase(item?.issuedTo?.lastName ?? '')
                      : ''
                  }, ${toHeaderCase(item?.issuedTo?.firstName)} ${
                    item?.issuedTo?.middleName
                      ? toHeaderCase(item?.issuedTo?.middleName ?? '')
                      : ''
                  }`
                : ''
              : `${
                  item?.application?.applicantInfo?.lastName
                    ? toHeaderCase(
                        item?.application?.applicantInfo?.lastName ?? ''
                      )
                    : ''
                } ${toHeaderCase(item?.application?.applicantInfo?.firstName)}`,

            item?.issuedTo?.email ?? item?.application?.applicantInfo?.email,
            this.formatCreatedDate(item?.validFrom),
            this.formatCreatedDate(item?.validTill),
          ],
          email:
            item?.issuedTo?.email ?? item?.application?.applicantInfo?.email,

          employer: item?.employer?.name,
          validTill: this.formatCreatedDate(item?.validTill),
          validFrom: this.formatCreatedDate(item?.validFrom),
          status:
            item?.renewalStatus === 'APPLIED_FOR_RENEWAL'
              ? this.getFormattedStatus(item?.renewalStatus)?.title
              : this.getFormattedStatus(item?.status, item?.validTill)?.title,
        };
      });
    console.log(_rowData);
    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    console.log('ans->', date);
    if (date) {
      const ans = moment(date).format('LLL');
      console.log('ans->', ans);
      return ans;
    }
  }

  private getFormattedStatus(status: string, date?: any): any {
    if (status) {
      switch (status) {
        case 'ACTIVE':
          return { key: 1, title: 'Active', color: '#00AB08' };
        case 'APPLIED_FOR_RENEWAL':
          return { key: 1, title: 'Applied for Renewal', color: '#ffb700' };
        case 'EXPIRING_SOON':
          return { key: 1, title: 'Expiring Soon', color: '#ffb700' };
        case 'EXPIRED':
          return { key: 1, title: 'Expired', color: '#E3040E' };
        case 'TERMINATED':
          return { key: 1, title: 'Terminated', color: '#E3040E' };
        case 'CREDENTIAL_DOES_NOT_EXIST':
          if (moment(date).isBefore(moment()))
            return { key: 1, title: 'Expired', color: '#E3040E' };
          const expiringIn = moment(date).diff(moment(), 'months');
          if (expiringIn <= 3)
            return { key: 1, title: 'Expiring Soon', color: '#ffb700' };
          return { key: 1, title: 'Active', color: '#00AB08' };
        case 'TERMINATION_REQUESTED':
          return { key: 1, title: 'Termination Requested', color: '#ffb700' };
        default:
          return '-';
      }
    }
  }
}
